// src/App.jsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './pages/MainLayout';
import Login from './pages/Login';

function App() {
  const getLogged = () => localStorage.getItem('logeado') === 'true';
  const [logeado, setLogeado] = useState(getLogged());

  useEffect(() => {
    const onStorage = () => setLogeado(getLogged());
    const onAuthChanged = () => setLogeado(getLogged());
    window.addEventListener('storage', onStorage);
    window.addEventListener('auth:changed', onAuthChanged);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('auth:changed', onAuthChanged);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={logeado ? <Navigate to="/rentas" /> : <Login />} />
        <Route path="/*" element={logeado ? <MainLayout /> : <Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
